import React from 'react';
import Price from "../Price";
import CartElementBooking from "./CartElementBooking";
import { Plural, Trans, useLingui } from '@lingui/react/macro';
import { useSelector } from 'react-redux';
import { isTacActivity, TAC_TEMPLATE_TYPES } from '../../constants/tacConstants';
import { dateStringToUrlString } from '../../utils/dateTimeUtils';

function CartElementTacBooking(props) {
    const currencySymbol = useSelector(state => state.bookings.currencySymbol);

    const entry = props.entry;
    const nrGuests = entry.nrAdults + entry.nrChildren;
    const isActivity = isTacActivity(entry.serviceProfileTemplateType);
    const {t} = useLingui();

    const guestCountText = isActivity
        ? <Trans id="x_guests_at_time">
            <div className="mb-1">
                <Plural value={nrGuests} one="# guest" other="# guests" />
            </div>
            <div>
                at <span className="font-bold">{entry.time}</span>
            </div>
        </Trans>
        : <Trans id="table_for_x_people">
            <div className="mb-1">
                Table for <Plural value={nrGuests} one="# person" other="# people" />
            </div>
            <div>
                at <span className="font-bold">{entry.time}</span>
            </div>
        </Trans>;

    const modalContent = (<>
        <div className="text-lg font-bold">
            <Trans id="issue_refund_for_booking">Issue refund for the following booking</Trans>
        </div>
        <div className="bg-primary-lightest p-4 mt-4">
            <div className="text-xl">
                {entry.name}
            </div>
            <div className="mt-1">
                {guestCountText}
            </div>
        </div>
        <div className="mt-2">
            <Price preText={t({id: "value"})} price={entry.price} currencySymbol={currencySymbol}/>
        </div>
    </>);

    const getToolTipText = () => {
        return `${t({id: "price_paid_for_booking", message: "Price paid for this booking (total)"})} ${currencySymbol}${entry.price}`;
    }

    return (
        <CartElementBooking
            name={entry.name}
            tooltipId={entry.id}
            tooltipText={getToolTipText()}
            linkTo={{ pathname: `/tac/restaurants/${dateStringToUrlString(props.date)}${isActivity ? `/${TAC_TEMPLATE_TYPES.ACTIVITY}` : ''}` }}
            imageReference={entry.serviceProfileId}
            modalContent={modalContent}
            refundIds={[entry.id]}
        >
            {guestCountText}
        </CartElementBooking>
    )
}

export default CartElementTacBooking;